export default __webpack_public_path__ + "static/media/Waifu.c40c777b.gif";